import React from "react";
import { useRef, useEffect, useState } from "react";
import "./OnlineBooking.css"
import {
  GetConfig,
  GetPaymentServiceDetails,
  ConnectStripeAccount,
  UpdateAcceptOnlinePaymentsOption,
  GetLoginLink,
  DisconnectStripeAccount
} from './Requests';
import {PulseLoader } from "react-spinners";
import {
  notifyError,
  notifySuccess
} from '../../Barber/Response/ResposeHandler'
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Payments = (props) => {
    const [config, setConfig] = useState(props.config)
    const [paymentServiceDetails, setPaymentServiceDetails] = useState(props.paymentServiceDetails)
    const [connectStripeAccountLoading, setConnectStripeAccountLoading] = useState(false)
    const [status , setStatus] = useState(props.status)
    const [enabledOnlinePaymentsButton, setEnableOnlinePaymentsButtons] = useState(props.config.acceptOnlinePayments)
    const [manageAccountButtonLoading, setManageAccountButtonLoading] = useState(false)
    const [disconnectAccountButtonLoading, setDisconnectAccountButtonLoading] = useState(false)




    function ConnectStripAccountButtonClick()
    {
    setConnectStripeAccountLoading(true)
    ConnectStripeAccount().then((res) => {
        if(res.status === 200) {
        window.open(res.data)
        }
    }).finally(() => {
        setConnectStripeAccountLoading(false)
    })
    }


function updateAcceptPaymentsOption(e)
{
  console.log(e.target.checked)
    UpdateAcceptOnlinePaymentsOption(e.target.checked).then((res) => {
    if (res.status === 200 && e.target.checked === true)
      {
        notifySuccess("Online payments are turned on")
        setEnableOnlinePaymentsButtons(true)
      }
    if (res.status === 200 && e.target.checked === false)
      {
        notifySuccess("Online payments are turned Off")
        setEnableOnlinePaymentsButtons(false)
      }
    }).catch((error) => {
      notifyError("There was an issue turning on online payments, please try again or contact support")

    }).finally((f) => {
    })
}

function ManageStripeAccountClicked()
{
  setManageAccountButtonLoading(true)
  GetLoginLink().then((res) => {
    if (res.status === 200)
      {
        window.open(res.data)
      }
    }).catch((error) => {

    }).finally((f) => {
      setManageAccountButtonLoading(false)
    })
}

function DisconnectAccountClicked()
{
  setDisconnectAccountButtonLoading(true)
    DisconnectStripeAccount().then((res) => {
    if (res.status === 200)
      {
        props.GetConfigWrapper()
      }
    }).catch((error) => {
      notifyError("Unable to disconnect stripe account, please check stripe dashboard for any pending funds or contact support.")
    }).finally((f) => {
      setDisconnectAccountButtonLoading(false)
    })
}

   return (
         <main>
            {/* <ToastContainer /> */}
            {/* <h1>Payments</h1> */}
            {config.stripeAccountId === null ?
            <div>
              <h1>Payments</h1>
                <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
                  <button onClick={ConnectStripAccountButtonClick} className='connect-button mb-3'>
                    
                    {!connectStripeAccountLoading ?
                    "Connect Stripe Account":
                    <PulseLoader 
                      color={'#eee'}
                      loading={connectStripeAccountLoading}
                      size={10}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                    }
                    </button>
                </div>
            </div>
            :
            !config.detailsSubmitted ?
            <div>
              <h1>Payments</h1>
                <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
                  <button onClick={ConnectStripAccountButtonClick} className='finish-setup-button mb-3'>Finish Stripe Account Setup</button>
                </div>
            </div>
            :
            <div>
                        

    <div className="stripe-container">
      <div className="header-stripe">
        {/* <h2>Stripe Connect Settings</h2> */}
          <div className={`status mb-3 ${status.toLowerCase().replace(" ", "-")}`}>
          {status === "Connected" ? "Connected to stripe account" : status === "no payouts" ? "Stripe payouts are currently not setup, please finish stripe setup" : status === "no charges" ? <span>Stripe charges are currently not setup, please finish stripe setup</span>: "" }
        </div>
        <h1>Payments</h1>
        <div className="stripe-toggle-row">
          <label className='enable-payments-switch-label'>Accept Online Payments for services</label>
          {/* <label style={{marginLeft:"1rem", marginTop:"1.3rem"}} className="switch">
          <input
            type="checkbox"
            defaultChecked={enabledOnlinePaymentsButton}
            onChange={(e) => {updateAcceptPaymentsOption(e)}}
          />
          <span className="slider round"></span>
          </label> */}
                          <div style={{marginRight:"2rem", marginBottom:"1rem"}} className="live-switch-wrapper">
                    <input
                        className="toggle-switch"
                        type="checkbox"
                        defaultChecked={enabledOnlinePaymentsButton}
                        id="logon"
                        onChange={(e) => {updateAcceptPaymentsOption(e)}}
                    />
                    <label htmlFor='logon' className="switch-label"/>
                </div>
        </div>
      </div>
<div className="stripe-info-section">
  <div className="stripe-info-card">
    <label>Available Funds</label>
    <p style={{fontSize:"2rem"}}>£{Number(paymentServiceDetails.availableFunds/100).toFixed(2)}</p>
  </div>
  <div className="stripe-info-card">
    <label>Pending Funds</label>
    <p style={{fontSize:"2rem"}}>£{Number(paymentServiceDetails.pendingFunds/100).toFixed(2)}</p>
  </div>
</div>
      <div>
        <div className='divider'>

        </div>
        <h3 className="heading-three">Stripe Account</h3>
        <div className="stripe-action-buttons">
          <button onClick={ManageStripeAccountClicked} className="stripe-manage-button">
            {!manageAccountButtonLoading ? 
            "Manage Account" :
            <PulseLoader 
                color={'#eee'}
                loading={manageAccountButtonLoading}
                size={8}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
            }
            {/* Manage Stripe Account */}

          </button>
          <button onClick={DisconnectAccountClicked} className="stripe-delete-button">
            {disconnectAccountButtonLoading ?
                        <PulseLoader 
                color={'#e63e3e'}
                loading={disconnectAccountButtonLoading}
                size={8}
                aria-label="Loading Spinner"
                data-testid="loader"
            /> :
            "Disconnect Account"
            }
          </button>
        </div>
      </div>
        <div className='divider'>

        </div>
      <div className="help-section">
        <h3>Need Help?</h3>
        <ul>
          <li><a href="https://stripe.com/docs/connect/express-dashboard" target="_blank" rel="noopener noreferrer">What is Stripe Connect?</a></li>
          <li><a href="/support">Contact Support</a></li>
        </ul>
      </div>
    </div>
    </div>
          }
          </main>

   );
};

export default Payments;
